// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo_1dHgJ"};